<template>
    <div class="col-12">
    
        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-10 col-lg-6">
                <div class=" row text-center ml-5">
                    <div class="mb-5">
                        <img src="../../assets/tn_cybertech_grad_logo.png" class="tn-logo" style="width: 200px; height: auto;">
                    </div>
                    <h3 class="ui inverted purple text"><strong>Your Signature</strong></h3>
                    <p class="text-muted mt-4">Please sign in the box below using your mouse or finger.</p>
                </div>
                <div class="ui fitted divider mt-2"></div>
            </div>
        </div>


        <div class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-9">

                <div class="row ml-5">
                    <div class="container">
                        <VueSignaturePad id="signature" width="100%" height="300px" ref="signaturePad"
                            :options="{ onEnd: onSignatureEnd }" />
                    </div>

                </div>

                <div class="ui fitted divider mt-5"></div>


                <div class="mt-3">
                    <button class="ui button large basic purple fluid mt-4" @click="save()" :disabled="isEmpty"
                        type="submit">Next</button>
                    <button class="ui button large basic red fluid mt-4 mb-4" @click="clear()">Clear Signature</button>

                    <button class="ui button large basic grey fluid mt-4 mb-4" @click="back()">Back</button>
                </div>

            </div>
        </div>
    </div>
    

</template>
<script>
import { useAccountOpeningStore } from '@/stores/accountOpening';

export default {
    name: "Signature",
    setup() {
        const accountOpeningStore = useAccountOpeningStore();
        return { accountOpeningStore };
    },
    data() {
        return {
            isEmpty: true,
        };
    },
    computed: {
        storedSignature() { return this.accountOpeningStore.signature; },
    },
    mounted() {
        // Load signature from store if exists (for back/forward navigation)
        if (this.storedSignature) {
            this.$nextTick(() => {
                this.$refs.signaturePad.fromDataURL(this.storedSignature);
                this.isEmpty = false;
            });
        }
    },
    methods: {
        onSignatureEnd() {
            this.isEmpty = false;
        },
        undo() {
            this.$refs.signaturePad.undoSignature();
        },
        clear() {
            this.$refs.signaturePad.clearSignature();
            this.isEmpty = true;
        },
        save() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            this.isEmpty = isEmpty;

            if (!isEmpty) {
                // Save signature to store
                this.setSignature(data);
                this.$router.push("/omni/customer-details");
            }
        },
        back() {
            this.$router.push("/omni/account-type");
        },
        setSignature(data) { this.accountOpeningStore.setSignature(data); },
    }
};
</script>